import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { Col, ModalBody, ModalFooter, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Button from 'components/button/Button';
import { ManageLanguagesModalLoaderContainer } from './ManageLanguagesModal.styles';

const ManageLanguagesLoader = ({
  hideAutoTranslation,
}: {
  hideAutoTranslation: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalBody>
        <ManageLanguagesModalLoaderContainer>
          <LoadingPlaceholder linesCount={1.2} width="90%" />

          <Row>
            {Array.from({ length: 14 }).map((_, index) => (
              <Col key={index} md={5}>
                <LoadingPlaceholder
                  linesCount={1}
                  width="100%"
                  className="loading-placeholder-language"
                />
              </Col>
            ))}
          </Row>

          {!hideAutoTranslation && (
            <>
              <LoadingPlaceholder linesCount={1.2} width="50%" />
              <LoadingPlaceholder linesCount={1} width="100%" />
            </>
          )}
        </ManageLanguagesModalLoaderContainer>
      </ModalBody>

      <ModalFooter>
        <Button bsStyle="default" disabled>
          {t('common.cancel')}
        </Button>
        <Button bsStyle="primary" disabled>
          {t('common.save')}
        </Button>
      </ModalFooter>
    </>
  );
};

export default ManageLanguagesLoader;
